const styles = () => ({
	header: {
		height: '40px',
		minHeight: '40px'
	},
	footer: {
		alignSelf: 'flex-end',
		paddingBottom: '64px'
	},
	description: {
		margin: '24px auto 24px',
		maxWidth: '768px',
		width: '100%',

		fontSize: '18px',
		fontStyle: 'normal',
		fontWeight: 300,
		lineHeight: '24px',

		color: '#444444',

		'@global h1': {
			marginBottom: '16px'
		}
	},
	pdfContainer: {
		display: 'flex',
		flexFlow: 'column',
		flexShrink: '0',
		alignItems: 'center',
		margin: '16px auto 40px',
		width: '100%',
		'@global canvas': {
			margin: '16px',
			boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 3px 1px -2px rgba(0, 0, 0, 0.12)'
		}
	},
	'@media (min-width: 1920px)': {
		header: {
			paddingLeft: 'calc((100% - 1536px)/2)!important',
			paddingRight: 'calc((100% - 1536px)/2)!important'
		},
		footer: {
			paddingLeft: 'calc((100% - 1536px)/2)!important',
			paddingRight: 'calc((100% - 1536px)/2)!important'
		}
	},
	'@media (min-width: 1024px)': {
		header: {
			paddingRight: '10%',
			paddingLeft: '10%'
		},
		footer: {
			display: 'flex',
			flexFlow: 'column',
			paddingRight: '10%',
			paddingLeft: '10%',
			justifyContent: 'center',
			alignSelf: 'flex-end'
		},
		'@global html, body': {
			backgroundColor: '#EEE'
		}
	},
	'@media (max-width: 768px)': {
		description: {
			maxWidth: '87.5%'
		}
	}
});

export default styles;



// WEBPACK FOOTER //
// ./src/client/pages/main/file/pdf/styles.js